import { FieldType } from '@wix/wix-data-schema-types'
import {
  VECTOR_IMAGE_ROLE,
  VECTOR_IMAGE_ROLE_LINK_SUBROLE,
  VECTOR_IMAGE_ROLE_SRC_AND_LINK_SUBROLE,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const {
  address,
  date,
  dateTime,
  document,
  image,
  number,
  stringArray,
  text,
  email,
  url,
  video,
} = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Vector_Art',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 467,
    title: 'Connect_Panel_Title_Vector_Art',
    helpId: '753851ba-4055-41dc-a17d-8dee3921514b',
  },
  sections: [
    {
      role: VECTOR_IMAGE_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Image_Label',
          prop: 'src',
          supportedFieldTypes: [image],
          defaultFieldType: image,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
        {
          title: 'Connect_Panel_Connect_Link_Label',
          prop: 'link',
          supportedFieldTypes: [document, url, image, video],
          defaultFieldType: url,
          event: 'onClick',
          supportPageLinks: true,
          supportsActions: true,
          supportsReferenceFields: true,
          supportsPostSubmit: true,
          supportsUrlTarget: true,
          supportsUrlRel: true,
          requiresPrimaryConnection: true,
        },

        {
          title: 'connectVectorArtPanel.altTextBinding.title',
          prop: 'accessibility.ariaLabel',
          supportedFieldTypes: [
            text,
            email,
            number,
            dateTime,
            date,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'vector_art_live_preview_gfpp_desktop_main_action',
              label: 'Vector_Art_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
      subroles: [
        {
          name: VECTOR_IMAGE_ROLE_SRC_AND_LINK_SUBROLE,
          conditions: [
            { connectedProps: [{ prop: 'src' }, { prop: 'link' }] },
            {
              connectedProps: [{ prop: 'src' }],
              connectedEvents: [{ event: 'onClick' as const }],
            },
          ],
          manifest: {
            gfpp: {
              desktop: {
                mainAction1: {
                  actionId: 'vector_art_live_preview_gfpp_desktop_main_action',
                  label: 'Vector_Art_Live_Preview_GFPP_Desktop_Main_Action',
                },
                iconButtons: {
                  link: {
                    behavior: 'HIDE' as const,
                  },
                },
              },
            },
          },
        },
        {
          name: VECTOR_IMAGE_ROLE_LINK_SUBROLE,
          conditions: [
            { connectedProps: [{ prop: 'link' }] },
            { connectedEvents: [{ event: 'onClick' as const }] },
          ],
          manifest: {
            gfpp: {
              desktop: {
                mainAction1: 'DEFAULT1' as const,
                iconButtons: {
                  link: {
                    behavior: 'HIDE' as const,
                  },
                },
              },
            },
          },
        },
      ],
    },
  ],
  compactErrorPanel: true,
})
